import { registerApplication, start } from "single-spa";

const isCartPath = (pathname: string): boolean => pathname.includes("/cart/");
const isWishlistPath = (pathname: string): boolean => pathname.includes("/merkliste/");

registerApplication({
	name: "mf-cart",
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	/*@ts-ignore*/
	app: () => import("cart/MainCart"),
	activeWhen: ({ pathname }) => isCartPath(pathname),
});

registerApplication({
	name: "mf-productlist",
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	/*@ts-ignore*/
	app: () => import("productlist/PdpPlp"),
	activeWhen: ({ pathname }) => !isCartPath(pathname) && !isWishlistPath(pathname),
});

registerApplication({
	name: "mf-wishlist",
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	/*@ts-ignore*/
	app: () => import("wishlist/Wishlist"),
	activeWhen: ({ pathname }) => isWishlistPath(pathname),
});

start({
	urlRerouteOnly: true,
});
